import React, { useRef } from 'react';
// @ts-ignore
import styles from './DosageInput.module.scss';
import Input from '../../../../Components/Form/components/Input';
import LinkButton from '../../../../Components/Button/LinkButton';
import { Theme } from '../../../../Enums/Theme.enum';

interface Props {
	onChange: (dosage: string) => void;
	value?: string;
}

const PREDEFINED_OPTIONS = [
	'1-0-0',
	'0-1-0',
	'0-0-1',
	'1-1-0',
	'1-0-1',
	'1-1-1',
	'1-1-1-1',
];

const DosageInput: React.FC<Props> = ({ onChange }) => {
	const inputRef = useRef<HTMLInputElement | null>(null);

	const handleChangeInput = (event: React.ChangeEvent<HTMLInputElement>) => {
		const inputElement = event.target as HTMLInputElement;
		// @ts-ignore
		const newValue = inputElement.value;
		onChange(newValue);
	};

	const preselectInput = (option: string) => {
		// @ts-ignore
		inputRef.current!.value = option;
		onChange(option);
	};

	return (
		<div className={styles.wrapper}>
			<div className={styles.inputs}>
				<Input
					className={styles.inputWrapper}
					ref={inputRef}
					type='text'
					onChange={e => handleChangeInput(e)}
				/>
			</div>
			<div className={styles.buttons}>
				{PREDEFINED_OPTIONS.map((option, index) => (
					<LinkButton
						title={option}
						theme={Theme.BLUE}
						onClick={() => preselectInput(option)}
						key={index}
					/>
				))}
			</div>
		</div>
	);
};

export default DosageInput;
